var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{stroke:#000000;stroke-width:0.3237;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1962_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_536_",
    d: "M24.4,6.5H1.6C0.7,6.5,0,5.8,0,4.9V1.6C0,0.7,0.7,0,1.6,0h22.8C25.3,0,26,0.7,26,1.6v3.2 C26,5.8,25.3,6.5,24.4,6.5z M1.6,1.6v3.2h22.8V1.6H1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_417_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_533_",
    d: "M24.4,16.2H1.6c-0.9,0-1.6-0.7-1.6-1.6v-3.2c0-0.9,0.7-1.6,1.6-1.6h22.8c0.9,0,1.6,0.7,1.6,1.6v3.2 C26,15.5,25.3,16.2,24.4,16.2z M1.6,11.4v3.2h22.8v-3.2H1.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_418_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_530_",
    d: "M24.4,26.4H1.6c-0.9,0-1.6-0.7-1.6-1.6v-3.2c0-0.9,0.7-1.6,1.6-1.6h22.8c0.9,0,1.6,0.7,1.6,1.6v3.2 C26,25.6,25.3,26.4,24.4,26.4z M1.6,21.5v3.2h22.8v-3.2H1.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection);
export default __webpack_public_path__ + "static/media/Section.753fb012c6a2052b5dd823d4b0864d8c.svg";
export { ForwardRef as ReactComponent };